const defaultTimeOut = 1000;
export class Utils {
  static sendAnalyticsEvent = (thdAnalyticsEvent, timeOut = () => (defaultTimeOut)) => new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve();
      return;
    }
    if (!window.digitalData.event) {
      window.digitalData.event = [];

    }
    // eslint-disable-next-line no-unused-expressions
    window?.digitalData?.event?.push(thdAnalyticsEvent);
    window.setTimeout(resolve(), timeOut);
  });
}
const exportObj = {
  Utils,
};

export default exportObj;
